<template>
  <SchemaFormInternal ref="schemaFormRel" :schema="schema" :global-data="globalData" :value="modelValue"
    @value-change="onChange" @error="onError">
    <template #submit>
      <slot name="submit" />
    </template>
  </SchemaFormInternal>
</template>
<script>
import { ref, toRef, watch, defineComponent } from 'vue';
import comps from './components';
import './rules';

import SchemaFormInternal from './src';

SchemaFormInternal.useComponent(comps);

export default defineComponent({
  name: 'SchemaForm',
  components: { SchemaFormInternal: SchemaFormInternal.component },
  props: {
    schema: { type: Object, default: () => ({}) },
    modelValue: { type: Object, default: () => ({}) },
    globalData: { type: Object, default: () => ({}) },
  },
  emits: ['update:modelValue', 'error'],
  setup(props, { emit }) {
    const onChange = values => {
      emit('update:modelValue', values);
    };
    const onError = errors => {
      emit('error', errors);
      console.log('errors', errors);
    };
    console.log({ 'schema-----schemaform': props.schema })

    // hacky：手动设置vee-validate form的values
    const schemaFormRel = ref(null);
    const modelValue = toRef(props, 'modelValue');
    watch(modelValue, (nv, ov) => {
      try {
        if (nv !== ov) {
          schemaFormRel.value.formRef.setValues(props.modelValue);
        }
      } catch (err) {
        return;
      }
    });

    const validate = () => {
      return schemaFormRel.value.formRef.validate();
    };

    return {
      schemaFormRel,
      onChange,
      onError,
      validate,
    };
  },
});
</script>
<style lang="less" scoped></style>
